window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    try {
      var instance;
      if (constructor.prototype && constructor.prototype.constructor === constructor) {
        instance = new constructor(container);
      } else {
        instance = constructor(container) || {};
      }

      instance = Object.assign(instance, {
        id: id,
        type: type,
        container: container,
      });

      this.instances.push(instance);
    } catch (err) {
      console.error("Section initialization failed:", err);
    }
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderGrid = "column",
      sliderAutoplay = e.dataset.autoplay,
      autoPlayValue = false,
      autoPlayTime = parseInt(e.dataset.autoplayTime);
    
    if (sliderAutoplay == "true"){
      autoPlayValue =  {
          delay: autoPlayTime
        };
    }

    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      mobileShow = parseInt(e.dataset.showMobile);
    } else{
      sliderContainer = false;
    }

    var featuredCollection = new Swiper(sliderContainer, {
      loop: true,
      slidesPerView: mobileShow,
      spaceBetween: 30,
      autoplay: autoPlayValue,
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
        type: "fraction"
      },
      navigation: {
        nextEl: e.querySelector(".swiper-button-next"),
        prevEl: e.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });

    if(!sliderContainer == false && sliderAutoplay == "true"){
      sliderContainer.addEventListener('mouseenter', (e) => {
        featuredCollection.autoplay.stop();
      });
      sliderContainer.addEventListener('mouseleave', (e) => {
        featuredCollection.autoplay.start();
      });
    }  
  }
  return sliderProduct;
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections(),
    headerMainMenu = new theme.Sections(),
    headerMainMenuSlider = new theme.Sections();

    if (typeof theme.scrollingText === "function") sections.register("scrolling_bar", theme.scrollingText);
    if (typeof theme.headerSection === "function") sections.register("header", theme.headerSection());
    if (typeof theme.menuProductSlider === "function") headerMainMenuSlider.register("header", theme.menuProductSlider);
    if (typeof theme.headerSearch === "function") headerSearchModule.register("header", theme.headerSearch);
    if (typeof theme.CartDrawerActions === "function") headerCartModule.register("header", theme.CartDrawerActions);
    if (typeof theme.headerSticky === "function") headerStickyModule.register("header", theme.headerSticky);
    if (typeof theme.headerMainMenuModule === "function") headerMainMenu.register("header", theme.headerMainMenuModule);
    if (typeof theme.footerSection === "function") sections.register("footer", theme.footerSection());
    if (typeof theme.SlideShow === "function") sections.register("slideShow", theme.SlideShow);
    if (typeof theme.productTab === "function") sections.register("product-tab", theme.productTab);
    if (typeof theme.collectionProduct === "function") sections.register("collection-product", theme.collectionProduct);
    if (typeof theme.collectionSlider === "function") sections.register("product-slider", theme.collectionSlider);
    if (typeof theme.accordion === "function") sections.register('accordion', theme.accordion);
    if (typeof theme.lookbookSlider === "function") sections.register("lookbook", theme.lookbookSlider);
    if (typeof theme.timelineSlider === "function") sections.register("timeline", theme.timelineSlider);
    if (typeof theme.blog === "function") sections.register('blog', theme.blog);
    if (typeof theme.counter__Number === "function") sections.register('ctrnmbr', theme.counter__Number);
});